var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vx-card",
    { attrs: { title: "Position", "code-toggler": "" } },
    [
      _c("p", [
        _vm._v("You can change the position of the menu with the property "),
        _c("code", [_vm._v("position")]),
        _vm._v(" that as a value you can have: "),
        _c("code", [_vm._v("top")]),
        _vm._v(", "),
        _c("code", [_vm._v("right")]),
        _vm._v(", "),
        _c("code", [_vm._v("bottom")]),
        _vm._v(", "),
        _c("code", [_vm._v("left")]),
      ]),
      _c(
        "vs-alert",
        {
          staticClass: "mt-5",
          attrs: { color: "primary", icon: "new_releases", active: "true" },
        },
        [
          _c("p", [
            _vm._v("For the title of each tab the "),
            _c("code", [_vm._v("label")]),
            _vm._v(" property is implemented in the "),
            _c("code", [_vm._v("vs-tab")]),
            _vm._v(" component"),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "mt-5" },
        [
          _c(
            "vs-tabs",
            { attrs: { color: "rgb(32, 201, 192)" } },
            [
              _c(
                "vs-tab",
                { attrs: { label: "Top" } },
                [
                  _c(
                    "vs-tabs",
                    { attrs: { color: "rgb(201, 32, 178)" } },
                    [
                      _c("vs-tab", { attrs: { label: "Home" } }, [
                        _c("span", [
                          _vm._v(
                            "Jujubes gingerbread cake pastry biscuit jelly-o marshmallow. Chocolate cake jelly marshmallow topping. Danish caramels gummies tootsie roll marshmallow sweet croissant."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "Service" } }, [
                        _c("span", [
                          _vm._v(
                            "Halvah dessert fruitcake toffee oat cake tart oat cake topping jelly beans. Pudding sweet pie pastry lemon drops jujubes danish pie gingerbread. Liquorice powder wafer."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "login" } }, [
                        _c("span", [
                          _vm._v(
                            "Chocolate icing pie danish gummies. Dragée gummies toffee muffin chocolate bar marshmallow. Marshmallow chupa chups muffin cake icing pastry wafer."
                          ),
                        ]),
                      ]),
                      _c(
                        "vs-tab",
                        { attrs: { disabled: "", label: "Disabled" } },
                        [
                          _c("span", [
                            _vm._v(
                              "Macaroon icing lemon drops jelly-o. Bonbon pie tart chocolate bar pastry. Sugar plum bonbon candy canes dragée toffee dragée toffee."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "vs-tab",
                { attrs: { label: "Right" } },
                [
                  _c(
                    "vs-tabs",
                    { attrs: { position: "right", color: "rgb(29, 55, 194)" } },
                    [
                      _c("vs-tab", { attrs: { label: "Home" } }, [
                        _c("span", [
                          _vm._v(
                            "Jujubes gingerbread cake pastry biscuit jelly-o marshmallow. Chocolate cake jelly marshmallow topping. Danish caramels gummies tootsie roll marshmallow sweet croissant."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "Service" } }, [
                        _c("span", [
                          _vm._v(
                            "Halvah dessert fruitcake toffee oat cake tart oat cake topping jelly beans. Pudding sweet pie pastry lemon drops jujubes danish pie gingerbread. Liquorice powder wafer."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "login" } }, [
                        _c("span", [
                          _vm._v(
                            "Chocolate icing pie danish gummies. Dragée gummies toffee muffin chocolate bar marshmallow. Marshmallow chupa chups muffin cake icing pastry wafer."
                          ),
                        ]),
                      ]),
                      _c(
                        "vs-tab",
                        { attrs: { disabled: "", label: "Disabled" } },
                        [
                          _c("span", [
                            _vm._v(
                              "Macaroon icing lemon drops jelly-o. Bonbon pie tart chocolate bar pastry. Sugar plum bonbon candy canes dragée toffee dragée toffee."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "vs-tab",
                { attrs: { label: "Bottom" } },
                [
                  _c(
                    "vs-tabs",
                    {
                      attrs: { position: "bottom", color: "rgb(29, 55, 194)" },
                    },
                    [
                      _c("vs-tab", { attrs: { label: "Home" } }, [
                        _c("span", [
                          _vm._v(
                            "Jujubes gingerbread cake pastry biscuit jelly-o marshmallow. Chocolate cake jelly marshmallow topping. Danish caramels gummies tootsie roll marshmallow sweet croissant."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "Service" } }, [
                        _c("span", [
                          _vm._v(
                            "Halvah dessert fruitcake toffee oat cake tart oat cake topping jelly beans. Pudding sweet pie pastry lemon drops jujubes danish pie gingerbread. Liquorice powder wafer."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "login" } }, [
                        _c("span", [
                          _vm._v(
                            "Chocolate icing pie danish gummies. Dragée gummies toffee muffin chocolate bar marshmallow. Marshmallow chupa chups muffin cake icing pastry wafer."
                          ),
                        ]),
                      ]),
                      _c(
                        "vs-tab",
                        { attrs: { disabled: true, label: "Disabled" } },
                        [
                          _c("span", [
                            _vm._v(
                              "Macaroon icing lemon drops jelly-o. Bonbon pie tart chocolate bar pastry. Sugar plum bonbon candy canes dragée toffee dragée toffee."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "vs-tab",
                { attrs: { label: "Left" } },
                [
                  _c(
                    "vs-tabs",
                    { attrs: { position: "left", color: "danger" } },
                    [
                      _c("vs-tab", { attrs: { label: "Home" } }, [
                        _c("span", [
                          _vm._v(
                            "Jujubes gingerbread cake pastry biscuit jelly-o marshmallow. Chocolate cake jelly marshmallow topping. Danish caramels gummies tootsie roll marshmallow sweet croissant."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "Service" } }, [
                        _c("span", [
                          _vm._v(
                            "Halvah dessert fruitcake toffee oat cake tart oat cake topping jelly beans. Pudding sweet pie pastry lemon drops jujubes danish pie gingerbread. Liquorice powder wafer."
                          ),
                        ]),
                      ]),
                      _c("vs-tab", { attrs: { label: "login" } }, [
                        _c("span", [
                          _vm._v(
                            "Chocolate icing pie danish gummies. Dragée gummies toffee muffin chocolate bar marshmallow. Marshmallow chupa chups muffin cake icing pastry wafer."
                          ),
                        ]),
                      ]),
                      _c(
                        "vs-tab",
                        { attrs: { disabled: true, label: "Disabled" } },
                        [
                          _c("span", [
                            _vm._v(
                              "Macaroon icing lemon drops jelly-o. Bonbon pie tart chocolate bar pastry. Sugar plum bonbon candy canes dragée toffee dragée toffee."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("template", { slot: "codeContainer" }, [
        _vm._v(
          '\n<template>\n  <div>\n    <vs-tabs color="rgb(32, 201, 192)">\n\n      <vs-tab label="Top">\n        <!-- top -->\n        <vs-tabs color="rgb(201, 32, 178)">\n          <vs-tab label="Home">\n            <span>Jujubes ....</span>\n          </vs-tab>\n          <vs-tab label="Service">\n            <span>Halvah ....</span>\n          </vs-tab>\n          <vs-tab label="login">\n            <span>Chocolate .....</span>\n          </vs-tab>\n          <vs-tab disabled label="Disabled">\n            <span>Macaroon ......</span>\n          </vs-tab>\n        </vs-tabs>\n      </vs-tab>\n\n      <vs-tab label="Right">\n        <!-- right -->\n        <vs-tabs position="right" color="rgb(29, 55, 194)">\n          <vs-tab label="Home">\n            <span>Jujubes ....</span>\n          </vs-tab>\n          <vs-tab label="Service">\n            <span>Halvah ....</span>\n          </vs-tab>\n          <vs-tab label="login">\n            <span>Chocolate .....</span>\n          </vs-tab>\n          <vs-tab disabled label="Disabled">\n            <span>Macaroon ......</span>\n          </vs-tab>\n        </vs-tabs>\n      </vs-tab>\n\n      <vs-tab label="Bottom">\n        <!-- bottom -->\n        <vs-tabs position="bottom" color="rgb(29, 55, 194)">\n          <vs-tab label="Home">\n            <span>Jujubes ....</span>\n          </vs-tab>\n          <vs-tab label="Service">\n            <span>Halvah ....</span>\n          </vs-tab>\n          <vs-tab label="login">\n            <span>Chocolate .....</span>\n          </vs-tab>\n          <vs-tab :disabled="true" label="Disabled">\n            <div>Macaroon .....</div>\n          </vs-tab>\n        </vs-tabs>\n      </vs-tab>\n\n      <vs-tab label="Left">\n        <!-- left -->\n        <vs-tabs position="left" color="danger">\n          <vs-tab label="Home">\n            <span>Jujubes ....</span>\n          </vs-tab>\n          <vs-tab label="Service">\n            <span>Halvah ....</span>\n          </vs-tab>\n          <vs-tab label="login">\n            <span>Chocolate .....</span>\n          </vs-tab>\n          <vs-tab :disabled="true" label="Disabled">\n            <div>Macaroon .....</div>\n          </vs-tab>\n        </vs-tabs>\n      </vs-tab>\n    </vs-tabs>\n  </div>\n</template>\n        '
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }